import React, { useState, useEffect } from 'react';
import './HomePage.css';
import { FaArrowRight } from 'react-icons/fa'; // For CTA Button Icon
import Header from './Header';
import { Link, useNavigate } from "react-router-dom";
import bg1 from './bg-1.png';
import bg2 from './bg-2.png';
import bg3 from './bg-4.png';
import bg4 from './bg-5.png';
import Bot from './bot';
import logo1 from './logo-1.png';
import logo2 from './logo-2.png';
import logo3 from './logo-3.png';
import logo4 from './logo-4.png';
import footerLogo from './logo.svg';


const HomePage = ({
  isModalOpen,
  isRegisterModalOpen,
  setIsRegisterModalOpen,
  setIsModalOpen,
  setIsLoggedIn,
  setUsername,
  setAccessKey,
  remainingCredits,
  name,
}) => {

  // Updated handleClick logic
  function handleGetStartedClick() {
    const storedEmail = localStorage.getItem("email");
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
        // If user is logged in, navigate to the job description page
        navigate('/login');
    } else {
        // If user is not logged in, open the modal
        navigate("/job-description");
    }
}


  useEffect(() => {
    // Load Google Analytics
    const script1 = document.createElement('script')
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-V32YGHXF75'
    script1.async = true
    document.head.appendChild(script1)

    const script2 = document.createElement('script')
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-V32YGHXF75');
    `
    document.head.appendChild(script2)

    // Cleanup function
    return () => {
      document.head.removeChild(script1)
      document.head.removeChild(script2)
    }
  }, []) // Empty dependency array ensures this runs once on mount



function handleContactForm() {
  window.location.assign("https://forms.monday.com/forms/7b4a9ee9263f34d8924cdd24bce45236?r=use1");
}

function handleLogo() {
  navigate("/");
}

const accessToken = localStorage.getItem("access_token");

function handlePricingClick() {
  const storedEmail = localStorage.getItem("email");
  const accessToken = localStorage.getItem("access_token");

  if (!accessToken) {
      // If user is logged in, navigate to the job description page
      navigate('/login');
  } else {
      // If user is not logged in, open the modal
      navigate("/pricing");
  }
}
    const navigate = useNavigate();

    const [activeStep, setActiveStep] = useState(0);

    const steps = [
      {
        title: "Step 1: Create or Choose Job Role",
        content: "Tailor a job description that accurately reflects the qualifications and traits you're seeking. You can either create a new job posting or select from your previous templates, ensuring clarity in your hiring process.",
        background: bg1
      },
      {
        title: "Step 2: Upload Resumes",
        content: "Seamlessly upload resumes from your own database or external sources, and let MayaMaya Lite handle the organization and analysis for you.",
        background: bg2
      },
      {
        title: "Step 3: Analyze and Match using AI",
        content: "Our cutting-edge AI analyzes each resume for authenticity, verifying credentials and experiences. Based on your job description, MayaMaya Lite intelligently matches you with top candidates.",
        background: bg3
      },
      {
        title: "Step 4: Shortlist Candidates",
        content: "Once the AI presents the most promising candidates, review their profiles in detail and shortlist those who fit your criteria. Start hiring with confidence and streamline your hiring process.",
        background: bg4
      }
    ];

// onLoad function that will be passed to the Bot 
const handleBotLoad = (hubspot) => {
  //console.log("HubSpot chatbot loaded successfully:", hubspot);
  // You can add additional logic to interact with the HubSpot bot here if needed
};

return (
  <div style={{backgroundColor: "#f7f6f5"}}>
  <div className="homepage-unique">
  <Header
      name={name}
      setIsLoggedIn={setIsLoggedIn}
      setUsername={setUsername}
      setAccessKey={setAccessKey}
      remainingCredits={remainingCredits}
      setIsRegisterModalOpen={setIsRegisterModalOpen}
      setIsModalOpen={setIsModalOpen}
      isModalOpen={isModalOpen}
      isRegisterModalOpen={isRegisterModalOpen}
    />
    {/* Hero Section */}
    <section className="hero-section-unique">
      <div className="hero-content-unique">
        <h2 className="tagline-unique">Uncover Authentic Talent. Streamline Your Hiring.</h2>
        <h1 className="headline-unique">Revolutionize Your Recruitment with <span style={{color: "#672024", fontStyle: "italic"}}>MayaMaya Lite</span></h1>
        <p className="subheading-unique">AI-driven resume analysis and intelligent matching for perfect job fits, ensuring you never miss out on top talent.</p>
        <button className="cta-button-homepage" onClick={handleGetStartedClick}>
          GET STARTED
        </button>
      </div>
    </section>

    {/* Problem Statement 
      <section className="problem-statement-unique">
        <h2 className="section-title-unique">A Smarter Way to Recruit</h2>
        <p className="section-text-unique">
        Profile Validation: Verify candidate profiles for various discrepancies and duplicates.
        </p>
        <p className="section-text-unique">
        Job Matching: Match ideal candidates with your job requirements.
        </p>
        <p className="section-text-unique">
        Insightful Shortlisting: Uncover skills gaps and shortlist top candidates.
        </p>
        <button className="cta-button-homepage" onClick={handleGetStartedClick}>
                  Upload Resumes
                </button>
      </section>*/}

    {/* How it Works */}
    <div style={{backgroundColor: "#fff", padding: "50px 0"}}>
        <div className="how-it-works-title">
          <h2 className="tagline-unique">The Process</h2>
          <h2 className="section-title-hiw-unique">How MayaMaya Lite Works?</h2>
        </div>
        <section 
          id="how-it-works"
          className="how-it-works-unique" 
          style={{backgroundImage: `url(${activeStep !== null ? steps[activeStep].background : bg2})`}}
        >
          <div className="steps-container-unique">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className={`step-unique ${activeStep === index ? 'active' : ''}`}
                onClick={() => setActiveStep(activeStep === index ? null : index)}
              >
                <h3>{step.title}</h3>
                {activeStep === index && <p>{step.content}</p>}
              </div>
            ))}
          </div>
        </section>
      </div>

    {/* Benefits for Employers */}
    <section id="benefits" className="benefits-section-unique">
    <div style={{width: "100%", display: "flex", justifyContent: "center"}}><h2 className="tagline-unique">The Benefits</h2></div>
      <h2 className="section-title-unique" style={{fontWeight: "500"}}>Unlock Efficient Hiring</h2>
      <div className="benefits-cards-unique">
        <div className="benefit-card-unique">
          <img src={logo1} alt="Save Time" />
          <h3>Save</h3>
          <h3>Time</h3>
          <p>Reduce your hiring time with automated resume analysis and intelligent candidate filtering, enabling you to focus on interviews rather than screening.</p>
        </div>
        <div className="benefit-card-unique">
          <img src={logo2} alt="Improve Accuracy" />
          <h3>Improve</h3>
          <h3>Accuracy</h3>
          <p>Verify candidates' educational and professional background instantly, ensuring that only credible and qualified individuals make it through to your review.</p>
        </div>
        <div className="benefit-card-unique">
          <img src={logo3} alt="Evaluate Experience" />
          <h3>Evaluate</h3>
          <h3>Experience</h3>
          <p>Simplify the application process, making it easier for recruiters to hire, leading to better recruitment and a positive experience.</p>
        </div>
        <div className="benefit-card-unique">
          <img src={logo4} alt="Decide with AI" />
          <h3>Decide </h3>
          <h3>with AI</h3>
          <p>Leverage AI insights on candidate potential and job fit, helping you make informed decisions without biases.</p>
        </div>
      </div>
    </section>

    <section id="pricing" className="homepage-pricing-section">
  <div className="homepage-pricing-content">
    <div className="homepage-pricing-left">
      <span className="tagline-unique">The Pricing</span>
      <h2 className="section-title-hiw-unique" style={{marginTop: "30px", marginBottom: "20px"}}>Flexible Pricing for Your Hiring Needs</h2>
      <p className="homepage-pricing-description">Choose the perfect plan to streamline your recruitment process and find top talent efficiently.</p>
    </div>
    <div className="homepage-pricing-right">
      <div className="homepage-pricing-cards">
        <div className="homepage-pricing-card" style={{border: "3px solid #5b161a"}}>
          <h3 className="card-title">
            <span className="highlight">1500 Credits</span>
          </h3>
          <p className="homepage-pricing-card-description">Our basic credit package for only essential features.</p>
          <div className="homepage-pricing-card-price">$19.99</div>
          <ul className="homepage-pricing-features">
            <li>Access to AI-powered resume analysis</li>
            <li>Intelligent candidate matching</li>
            <li>Detailed insights and reports</li>
          </ul>
          <button className="homepage-pricing-cta-button" style={{marginTop: "55px"}}>
            {/*accessToken ? "Upgrade Plan" : "Sign Up Now"*/} COMING SOON
          </button>
          <p style={{marginTop: "20px"}}>Get <strong>50 Credits</strong> on us.</p>
        </div>
        
        <div className="homepage-pricing-card" style={{border: "3px solid #113e3c"}}>
          <div className="card-badge">Active Now</div>
          <h3 className="card-title">
            <span className="highlight">3000 Credits</span>
          </h3>
          <p className="homepage-pricing-card-description">Our most popular credit package for advanced features.</p>
          <div className="homepage-pricing-card-price">$29.99</div>
          <ul className="homepage-pricing-features">
            <li>Access to AI-powered resume analysis</li>
            <li>Intelligent candidate matching</li>
            <li>Detailed insights and reports</li>
          </ul>
          <button onClick={handlePricingClick} className="homepage-pricing-cta-button" style={{marginTop: "55px"}}>
            {accessToken ? "Upgrade Plan" : "Sign Up Now"}
          </button>
          <p style={{marginTop: "20px"}}>Get <strong>50 Credits</strong> on us.</p>
        </div>
        
        <div className="homepage-pricing-card" style={{border: "3px solid #11293e"}}>
          <h3 className="card-title">
            <span className="highlight">5000 Credits</span>
          </h3>
          <p className="homepage-pricing-card-description">Our premium credit package for power users.</p>
          <div className="homepage-pricing-card-price">$49.99</div>
          <ul className="homepage-pricing-features">
          <li>Access to AI-powered resume analysis</li>
            <li>Intelligent candidate matching</li>
            <li>Detailed insights and reports</li>
            <li>Priority support</li>
          </ul>
          <button className="homepage-pricing-cta-button">
            {/*accessToken ? "Upgrade Plan" : "Sign Up Now"*/} COMING SOON
          </button>
          <p style={{marginTop: "20px"}}>Get <strong>150 Credits</strong> on us.</p>
        </div>
      </div>
    </div>
  </div>
</section>
  

    {/* Final Call to Action */}
    <section id="get-started" className="final-cta-section-unique">
    <div style={{width: "100%", display: "flex", justifyContent: "center", marginBottom: "10px"}}><h2 className="cta-tagline-unique" style={{fontSize: "0.7rem"}}>Try The Lite Version</h2></div>
      <h2>Get Started with</h2> 
      <h2>MayaMaya Lite Today</h2>
      <p>Discover the ease of AI-driven hiring. Save time, enhance accuracy, and shortlist top talent effortlessly.</p>
      <button className="cta-button-unique" onClick={handleGetStartedClick}>
        Get Started 
      </button>
      <button className="contact-form-cta" onClick={handleContactForm}>
        Contact Us
      </button>
    </section>
    
    <footer className="footer" style={{height: "100px", background: "#f7f6f5", padding: "20px 150px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
      <div className="footer-left">
        <img src={footerLogo} alt="Footer Logo" onClick={handleLogo} style={{height: "50px", cursor: "pointer"}} />
      </div>
      <p style={{color: "#000"}}>MayaMaya Suite of Products - MayaMaya Lite</p>
      <div className="footer-right" style={{display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "0.8rem"}}>
        <Link to="https://docs.google.com/document/d/1RN1r2ZiJ8uj6l-rIYqVCyxz-0GmDk9MY/edit" style={{color: "#5b161a", marginRight: "10px", textDecoration: "underline", fontWeight: "600"}}>Terms & Conditions</Link>
        <div style={{color: "#000", marginRight: "10px"}}>|</div>
        <Link to="https://docs.google.com/document/d/1GUX0DsM3OxqIOKnZVtKBBOp7HvMbLfetq-yqrPNgQqo/edit?tab=t.0#heading=h.hnmbcul91sh3" style={{color: "#5b161a", textDecoration: "underline", fontWeight: "600"}}>Privacy Policy</Link>
      </div>
    </footer>
    <Bot onLoad={handleBotLoad} />
  </div>
  </div>
);
};

export default HomePage;